import { render, staticRenderFns } from "./LeagueTable.vue?vue&type=template&id=632e9a14&scoped=true"
import script from "./LeagueTable.vue?vue&type=script&lang=js"
export * from "./LeagueTable.vue?vue&type=script&lang=js"
import style0 from "./LeagueTable.vue?vue&type=style&index=0&id=632e9a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632e9a14",
  null
  
)

export default component.exports